export { obtainInitialFirstLetters } from './obtainInitialsFirstLetters'
export { obtainRoleOfUser } from './obtainRoleOfUser'
export { definitionPaths } from './definitionPaths'
export { savePosIdLocalStorage } from './savePosIdLocalStorage'